import { defineMessages } from 'react-intl';

const messages = defineMessages({
  dossier: {
    id: 'mobileFooterNav.dossier',
    defaultMessage: 'Dossier',
  },
  create: {
    id: 'mobileFooterNav.create',
    defaultMessage: 'CRÉER',
  },
  commande: {
    id: 'mobileFooterNav.commande',
    defaultMessage: 'Commande',
  },
});

export default messages;
